module.exports = __webpack_public_path__ + "img/Allegory of woe.8794448c.webp";